import { StaggerItem } from './ScrollReveal';

/**
 * How-it-works step — section/how in Landing .pen (number chip + copy).
 */
export function StepCard({ number, title, description }) {
  return (
    <StaggerItem className="flex flex-col gap-space-4 mid:flex-1" scale={0.96}>
      <span className="flex h-12 w-12 items-center justify-center rounded-ds-full bg-gradient-to-br from-sage-500 to-sage-700 font-display text-type-display-stat font-bold text-sage-50">
        {number}
      </span>
      <div className="flex flex-col gap-space-2">
        <h3 className="font-display text-type-display-metric font-semibold text-foreground">
          {title}
        </h3>
        <p className="type-landing-lead max-w-prose">{description}</p>
      </div>
    </StaggerItem>
  );
}
